import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';
import { WorkflowSectionDto } from './workflow-section-dto.interface';
import { WorkflowTaskDto } from './workflow-task-dto.interface';

export interface WorkflowDto {
    workflowId: string;

    name: string;

    area: WorkflowArea;

    /** REV-22155 — missing = COMPANY. */
    subjectType?: SubjectType;

    sections: WorkflowSectionDto[];

    workflowTasks: WorkflowTaskDto[];

    createdAt: Date;

    updatedAt: Date;
}
